<script setup lang="ts">
import type { ExplainerRelation } from "~/types/article"

defineProps({
  note: {
    type: Object as PropType<ExplainerRelation>,
    required: true,
  },
})
</script>

<template>
  <USidenote :note="note" title-class="text-red-darker" />
</template>
